import { useState, useEffect } from 'react';

const mergeTwoDatasets = (data, dataTwo, hAxis) => {
  const mergeHAxis = hAxis.merge;

  return data.map((each, index) => {
    const correspondingData = dataTwo[index];

    return [mergeHAxis && correspondingData ? `Day ${index + 1}` : each[0], each[1], correspondingData ? correspondingData[1] : null];
  });
};

const FIRST_DATASET_TITLE = 'Count';
const SECOND_DATASET_TITLE = 'Count (Prior)';

const baseHeaderOptions = { isInclude: true, base: ['Day', FIRST_DATASET_TITLE], second: SECOND_DATASET_TITLE };
const baseHAxisOptions = { merge: false };

export const useMergedData = (data, dataTwo, isComparing, headersOptions, hAxisOptions) => {
  const [chartData, setChartData] = useState([]);

  const headers = { ...baseHeaderOptions, ...headersOptions };
  const hAxis = { ...baseHAxisOptions, ...hAxisOptions };

  useEffect(() => {
    if (!data || !data.length) return;

    if (isComparing && dataTwo && dataTwo.length) {
      const mergedData = mergeTwoDatasets(data, dataTwo, hAxis);
      setChartData([...(headers.isInclude ? [[...headers.base, headers.second]] : []), ...mergedData]);
      return;
    }

    setChartData([...(headers.isInclude ? [headers.base] : []), ...data]);
  }, [data, dataTwo, isComparing]);

  return chartData;
};
